import { useNavigate } from 'react-router-dom';
import './ClubCard.css';

const PLACEHOLDER_COLOR = 'rgba(234, 234, 234, 0.73)';

// 카테고리 데이터를 배열 형태로 변환
function parseCategories(category) {
  if (!category) return [];
  if (Array.isArray(category)) return category;
  try { return JSON.parse(category); } catch { return [category]; }
}

// 동아리 정보를 카드 형태로 표시하는 컴포넌트
export default function ClubCard({ club,isMember }) {
  const navigate = useNavigate();

  // 동아리 카테고리 목록
  const categories = parseCategories(club.category);

  // 모집 여부 확인
  const isRecruiting = club.recruitment_status === '모집 중';

  return (
    // 카드 클릭 시 상세 페이지로 이동
    <div className="club-card" onClick={() => navigate(`/clubs/${club.id}`)}>
      {/* 동아리 이미지 영역 */}
      <div className="club-card-image-wrap">
        {club.image_url ? (
          <img src={club.image_url} alt={club.name} className="club-card-img" />
        ) : (
          // 이미지가 없을 경우 동아리명 표시
          <div
            className="club-card-img-placeholder"
            style={{ backgroundColor: PLACEHOLDER_COLOR }}
          >
            {club.name}
          </div>
        )}

        {/* 가입 여부 및 모집 상태 표시 */}
        <span
          className={`club-card-badge ${
            isMember
              ? 'badge-joined'
              : isRecruiting
              ? 'badge-open'
              : 'badge-closed'
          }`}
        >
          {isMember
            ? '가입'
            : isRecruiting
            ? '모집 중'
            : '모집 종료'}
        </span>
      </div>

      {/* 카드 본문 */}
      <div className="club-card-body">
        {/* 동아리 이름 */}
        <h3 className="club-card-name">{club.name}</h3>

        {/* 동아리 설명 */}
        <p className="club-card-desc">{club.description}</p>

        {/* 카테고리 및 회원 수 */}
        <div className="club-card-footer">
          <div className="club-card-tags">
            {categories.slice(0, 2).map((cat) => (
              <span key={cat} className="club-card-tag">{cat}</span>
            ))}
          </div>

          {/* 회원 수 표시 */}
          {club.member_count > 0 && (
            <span className="club-card-members">멤버 {club.member_count}명</span>
          )}
        </div>
      </div>
    </div>
  );
}